'use client';

import { getCoreRowModel, useReactTable } from '@tanstack/react-table';

import { DataTable } from '@/components/data-table';
import { useApiV1Ctx } from '@/components/providers/v1-api';

import { SERVICE_PLAN_TEMPLATE_COLUMNS } from './columns';

export function ServicePlanTemplatesTable() {
  const { api } = useApiV1Ctx();
  const { data } = api.servicePlanTemplates.getAllServicePlanTemplatesGet.useQuery();

  const table = useReactTable({
    data: data ?? [],
    columns: SERVICE_PLAN_TEMPLATE_COLUMNS,
    getCoreRowModel: getCoreRowModel(),
  });

  return (
    <div className='rounded-md border'>
      <DataTable table={table} columns={SERVICE_PLAN_TEMPLATE_COLUMNS} className='overflow-hidden' />
    </div>
  );
}
